import { useRecoilValue } from 'recoil';
import type { RequestContextViewModel } from 'autogen/swagger/all';
import { requestDataState } from 'recoilState/atoms/requestDataState';

export default function useRequestContext() {
    const state = useRecoilValue(requestDataState);

    return state?.requestContextModel || ({} as RequestContextViewModel);
}
